import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { HeaderService } from 'src/app/core/header.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss'],
  standalone: false
})
export class GlobalHeaderComponent {

  @Input() showBack: boolean = false;
  @Input() showPremium: boolean = false;
  @Input() showActions: boolean = false;
  @Input() user?: User;

  showStreakWidget: boolean = false;

  constructor(
    private router: Router,
    private location: Location,
    private headerService: HeaderService
  ) {}

  ngOnInit() {}

  navigate(route: string) {
    this.router.navigate([route]);
  }

  navigateBack() {
    this.location.back();
  }

  actionsClicked() {
    this.headerService.triggerActionsClick();
  }

  getPremium() {
    this.router.navigate(['get-premium']);
  }

  showStreak() {
    this.showStreakWidget = true;
  }

  handleNavbarToggleClick() {
    this.headerService.triggerSidebarToggle();
  }
}
